export const DEBOUNCE_SEARCH_VALUE = 1000;
